// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { analyticCategoryEnum } from './AnalyticCategoryEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const analyticId = (z.number());
export const analytic = z.object({
    id: analyticId,
    slug: z.string(),
    name: z.string(),
    category: analyticCategoryEnum,
    description: z.string().nullable(),
    icon: z.string().nullable(),
    enabled: z.boolean(),
    sort_order: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const analyticInitializer = z.object({
    id: analyticId.optional(),
    slug: z.string(),
    name: z.string(),
    category: analyticCategoryEnum,
    description: z.string().optional().nullable(),
    icon: z.string().optional().nullable(),
    enabled: z.boolean().optional(),
    sort_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const analyticMutator = z.object({
    id: analyticId.optional(),
    slug: z.string().optional(),
    name: z.string().optional(),
    category: analyticCategoryEnum.optional(),
    description: z.string().optional().nullable(),
    icon: z.string().optional().nullable(),
    enabled: z.boolean().optional(),
    sort_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=Analytic.js.map